import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const BadgeWrap = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  column-gap: 8px;
  color: ${p => p.theme.lightestGray ?? '#7a8e96'};
  font-size: 14px;
`

const IncludedBadge = ({ included }) => (
  <BadgeWrap>
    <svg width='22' height='22' viewBox='0 0 24 24' aria-hidden='true'>
      <circle cx='12' cy='12' r='12' fill='currentColor' />
      {included ? (
        <path
          d='M6.5 12.4 L10.3 16.2 L17.5 8.2'
          fill='none'
          stroke='#ffffff'
          strokeWidth='2.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      ) : (
        <path
          d='M8 8 L16 16 M16 8 L8 16'
          fill='none'
          stroke='#ffffff'
          strokeWidth='2.2'
          strokeLinecap='round'
        />
      )}
    </svg>
    {included ? 'Included' : 'Excluded'}
  </BadgeWrap>
)

IncludedBadge.propTypes = {
  included: PropTypes.bool.isRequired,
}

export default IncludedBadge
